<div class="map-results-page__contents-wrapper">
  <div class="row d-flex flex-md-row-reverse">
    <div class="col-12 col-md-12 col-lg-6 col-xl-7 pb-0 ten-map-outer-wrapper">
      <div
        *ngIf="geoLocations?.features?.length"
        class="ten-map-wrapper"
        [ngClass]="{ 'ten-map-wrapper--bigger': componentData && componentData.style === 'modern' }"
      >
        <ten-map
          class="ten-map"
          [mapId]="mapId"
          [geoJSON]="geoLocations"
          [overlayText]="overlayText"
          [hidePopupText]="isMobile"
          [activeFeatureId]="(activeSearchResultItemId$ | async) || null"
          [zoomToActivePin]="false"
          [isRecenterButton]="isRecenterButton"
          [closePopupOnClick]="false"
          (pinList)="getPinList($event)"
          (zoomIn)="zoomIn.emit($event)"
          (zoomOut)="zoomOut.emit($event)"
          (featureClicked)="pinClicked($event)"
        >
        </ten-map>
      </div>
    </div>
    <div class="col-12 col-md-12 col-lg-6 col-xl-5">
      <div *ngIf="cardList?.length <= 0 && searchResultAsCards?.length > 0 && !isLoader">
        <p class="text-center mt-4">{{ noPinsVisibleText | translate }}</p>
      </div>
      <div *ngIf="cardList?.length <= 0 && searchResultAsCards?.length > 0 && isLoader">
        <img
          src="assets/images/ring-alt.gif"
          [alt]="'CardListContentComponent:Loading' | translate"
          class="d-block mx-auto mt-4"
        />
      </div>
      <div class="card-list">
        <div
          *ngFor="let cardItem of cardList; let i = index"
          id="card_element_{{ cardItem?.uuid || cardItem?.id }}"
          class="card-item"
        >
          <ten-card
            *ngIf="cardItem?.uuid || cardItem?.id"
            id="result_card_{{ i }}"
            [cardData]="cardItem"
            [badgesOnTop]="badgesOnTop"
            [enableAnchorLink]="true"
            [asyncPageLoad]="asyncPageLoad"
            [openNewTab]="openNewTab"
            (mouseenter)="showActivePinWithoutZoom(cardItem.uuid || cardItem.id)"
            (mouseleave)="showActivePinWithoutZoom()"
            (cardClicked)="cardClick($event, cardItem)"
          >
            <ten-card-value-proposition>
              <price-on-card
                [valueProposition]="cardItem?.body?.valueProposition"
                [prefix]="'TravelHotelSearchResult:PricePrefix' | translate"
                [suffix]="'TravelHotelSearchResult:PriceSuffix' | translate"
              ></price-on-card>
            </ten-card-value-proposition>
          </ten-card>
        </div>
      </div>
    </div>
  </div>
</div>
